import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createSlice } from '@reduxjs/toolkit';
import { fetchBindingThunk } from "./thunks";
var initialState = {
  unBinded: false,
  from3DS: false,
  fetched: false,
  content: null,
  payId: null,
  binding: {},
  pendingBinding: false,
  hasCaptchaError: false,
  sberSdkEnabled: false
};
export var sberPaySlice = createSlice({
  name: 'features/sberPay',
  initialState: initialState,
  reducers: {
    commonSetter: function commonSetter(state, action) {
      return _objectSpread(_objectSpread({}, state), action.payload);
    },
    setUnBinded: function setUnBinded(state, action) {
      state.unBinded = action.payload;
    },
    setPaymentStatus: function setPaymentStatus(state, action) {
      state.paymentStatus = action.payload;
    },
    setFrom3DS: function setFrom3DS(state, action) {
      state.from3DS = action.payload;
    },
    setSberPayId: function setSberPayId(state, action) {
      state.payId = action.payload;
    },
    setBinding: function setBinding(state, action) {
      state.binding = action.payload;
    },
    setErrorText: function setErrorText(state, action) {
      if (action.payload) {
        state.content.error.description = action.payload;
      }
    },
    setHasCaptchaError: function setHasCaptchaError(state, action) {
      state.hasCaptchaError = action.payload;
    }
  },
  extraReducers: _defineProperty(_defineProperty(_defineProperty({}, fetchBindingThunk.pending, function (state) {
    state.pendingBinding = true;
  }), fetchBindingThunk.fulfilled, function (state, _ref) {
    var payload = _ref.payload;
    state.binding = payload;
    state.pendingBinding = false;
    state.fetched = true;
  }), fetchBindingThunk.rejected, function (state) {
    state.pendingBinding = false;
    state.fetched = true;
  })
});